import dataService from "./dataService";
import { formatTime } from "./helpers";

export default class wwParser {
  // all artists
  artistsArr = [];
  // shows arranged by showid
  _showsById = {};
  // an array of shows by day
  showsByDay = {};
  // shows in an array
  showsArr = [];
  // array of days of shows, ie festival days
  showsDays = [];
  // shows organized by day, then by place for each day, each place has array of shows w/ artists
  showsByDayPlace = {};
  // shows organized by day, then by time, each time has array of shows w/ artists
  showsByDayTime = {};
  // artists organized by day
  artistsByDay = {};
  // mode
  mode = "";
  // first letters of each artist
  artistsAz = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "#",
  ];

  constructor(dataPath) {
    this.dataPath = dataPath;
  }
  async initialize() {
    try {
      const ds = new dataService(this.dataPath);
      const [shows, artistsArr, mode] = await Promise.all([
        ds.getShowsData(),
        ds.getArtistsData(),
        ds.getMode(),
      ]);
      this.mode = mode;
      this._showsById = shows;
      this.artistsArr = artistsArr;
      this.artistsArr = this.sortArtistsArrByName(this.artistsArr);
      this.showsArr = this.convertShowsByIdToArray(this._showsById);
      this.artistsArr = this.addShowsToArtists(this.artistsArr, this.showsArr);
      this.artistsBillingOrder = this.sortArtistsByBillingOrder(
        Object.assign([], this.artistsArr)
      );
      // put the artists object in the array of shows
      this.showsArr = this.applyArtistsToShowsArr(this.showsArr, artistsArr);
      // figure out what days the festival runs
      this.showsDays = this.getShowsDays(this.showsArr);
      // organize the shows by day, each day contains array of shows
      this.showsDays.forEach((day) => {
        this.showsByDay[day] = this.getShowsByDay(day, this.showsArr);
      });
      // get shows by day, then by place
      this.showsDays.forEach((day) => {
        this.showsByDayPlace[day] = this.getShowsByDayPlace(
          this.showsByDay[day]
        );
      });
      // get shows by day, then by time
      this.showsDays.forEach((day) => {
        this.showsByDayTime[day] = this.getShowsByDayTime(this.showsByDay[day]);
      });
      // get artists by day
      this.showsDays.forEach((day) => {
        this.artistsByDay[day] = this.getArtistsByDay(
          this.showsByDay[day],
          this.artistsArr
        );
      });
      this.artistsAz = this.getArtistsAz(this.artistsArr);
    } catch (err) {
      console.error(err);
      console.error("unable to parse shows!");
    }
  }
  convertShowsByIdToArray(shows) {
    const showsArr = [];
    for (const prop in shows) {
      showsArr.push(shows[prop]);
    }
    return showsArr;
  }
  sortArtistsArrByName(artistsArr) {
    // split the artists by alpha and non-alpha titles
    let alpha = artistsArr.filter((artist) => {
      const first = artist.title.slice(0, 1);
      return /^[a-zA-Z()]$/.test(first) === true;
    });
    let nonAlpha = artistsArr.filter((artist) => {
      const first = artist.title.slice(0, 1);
      return /^[a-zA-Z()]$/.test(first) === false;
    });
    // sort each
    alpha = alpha.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
    });
    nonAlpha = nonAlpha.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
    });
    // concat the non-alpha to end
    return alpha.concat(nonAlpha);
  }
  sortArtistsByBillingOrder(artistsArr) {
    return artistsArr.sort((a, b) => {
      const numA =
        typeof a.billingOrder === "string"
          ? Number(a.billingOrder)
          : a.billingOrder;
      const numB =
        typeof b.billingOrder === "string"
          ? Number(b.billingOrder)
          : b.billingOrder;
      if (numA < numB) {
        return -1;
      }
      if (numA > numB) {
        return 1;
      }
    });
  }
  getShowsByDayPlace(thisDaysShows) {
    let places = [];
    // sort the shows by ascending start time
    thisDaysShows = thisDaysShows.sort((a, b) => {
      if (a.time_start < b.time_start) {
        return -1;
      }
      if (a.time_start > b.time_start) {
        return 1;
      }
    });
    thisDaysShows.forEach((show) => {
      const venue = show.venue ? show.venue.title : "";
      if (
        !places.some((place) => {
          return place.venue === venue;
        })
      ) {
        places.push({
          venue: venue,
          shows: thisDaysShows.filter((show) => {
            return (show.venue ? show.venue.title : "") === venue;
          }),
        });
      }
    });
    // sort the places by ascending venue name
    places = places.sort((a, b) => {
      if (a.venue < b.venue) {
        return -1;
      }
      if (a.venue > b.venue) {
        return 1;
      }
    });
    return places;
  }
  getArtistsByDay(thisDaysShows, artistsArr) {
    let artists = [];
    const artistsById = {};
    // make hash table of artists
    artistsArr.forEach((artist) => {
      artistsById[artist.id] = artist;
    });
    thisDaysShows.forEach((show) => {
      const artist = artistsById[show.object._id];
      if (artist) {
        artists.push(artistsById[show.object._id]);
      }
    });
    artists = artists.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
    });
    return artists;
  }
  getShowsByDayTime(thisDaysShows) {
    const times = [];
    // sort the shows by ascending start time
    thisDaysShows = thisDaysShows.sort((a, b) => {
      if (a.time_start < b.time_start) {
        return -1;
      }
      if (a.time_start > b.time_start) {
        return 1;
      }
    });
    // we want to arrange the shows by round times
    thisDaysShows.forEach((show) => {
      const floorTime = this.floorTimeStrToAP(show.time_start);
      if (
        !times.some((timeRow) => {
          return timeRow.time_start === floorTime;
        })
      ) {
        times.push({
          time_start: floorTime,
          shows: thisDaysShows.filter((show) => {
            return this.floorTimeStrToAP(show.time_start) === floorTime;
          }),
        });
      }
    });
    return times;
  }
  floorTimeStrToAP(timeStr) {
    if (!timeStr) {
      // default to 12:00:00
      timeStr = "12:00:00";
    }
    const timeStrSplit = timeStr.split(":");
    return formatTime(`${timeStrSplit[0]}:00:00`);
  }
  isSameHour(time1, time2) {
    return this.floorTimeStrToAP(time1) === this.floorTimeStrToAP(time2);
  }
  applyArtistsToShowsArr(showsArr, artistsArr) {
    const artistsById = {};
    // make hash table of artists
    artistsArr.forEach((artist) => {
      artistsById[artist.id] = artist;
    });
    showsArr.forEach((show) => {
      show.artist = artistsById[show.object._id];
    });
    return showsArr;
  }
  getShowsDays(showsArr) {
    const showsDays = [];
    showsArr.forEach((show) => {
      if (!showsDays.includes(show.date_start)) {
        showsDays.push(show.date_start);
      }
    });
    showsDays.sort();
    return showsDays;
  }

  getShowsByDay(day, showsArr) {
    return showsArr.filter((show) => {
      return show.date_start === day;
    });
  }
  addShowsToArtists(artistsArr, showsArr) {
    artistsArr.forEach((artist) => {
      artist.shows = [];
      const artistShows = showsArr.find((show) => {
        return show.object._id === artist._id;
      });
      if (artistShows) {
        artist.shows = artistShows.map((show) => {
          return {
            startDt: show.date_start,
            endDt: show.date_end,
            startTime: show.time_start,
            endTime: show.time_end,
            venue: show.venue ? show.venue.title : "",
          };
        });
      }
    });
    return artistsArr;
  }
  getArtistsAz(artists) {
    const az = [];
    let hasNonAlpha = false;
    artists.forEach((artist) => {
      const firstLetter = artist.title.slice(0, 1).toUpperCase();
      if (!az.includes(firstLetter)) {
        if (/^[a-zA-Z()]$/.test(firstLetter)) {
          az.push(firstLetter);
        } else {
          hasNonAlpha = true;
        }
      }
    });
    // put the non alpha symbol # last
    if (hasNonAlpha) {
      az.push("#");
    }
    return az;
  }
}
